export default "__VITE_ASSET__Dw4OSkN___"